<template>
  <div class="order-item">
    <div class="order-title">
      <div class="title-left">
        <div class="title-num">{{order.user_order_id}}</div>
        <div class="title-name">{{order.product_name}}</div>
      </div>
      <div class="title-right">
        <div class="title-status" :class="calculateOrderStatusClass(order, 1)">{{$maps.ORDER_STATUS[order.order_status]}}</div>

        <order-invoice-tag :order="order"></order-invoice-tag>

        <button-more
          class="m-r-30"
          :order="order"
          :is-admin="true"
        ></button-more>
        <div class="btn-box">
           <a class="el-button el-button--primary" v-if="order.order_status == 3" @click="goOrderConfirm(order)">立即支付</a>
          <router-link class="el-button el-button--primary" v-else :to="{name: 'orderDetail', params: {oid: order.user_order_id}, query: {admin: 1}}">查看订单</router-link>
        </div>
      </div>
       
    </div>

    <!-- 申请人 -->
    <div class="insurant-list" :class="{'no-bottom-border': (ind === order.applicant.length - 1) || (!collapsed && ind === 2)}"
     v-for="(ins, ind) in collapsed ? order.applicant : order.applicant.slice(0, 3)" :key="ind" >
      <div class="insurant-name">{{ins.applicant_name}}</div>
      <div class="insurant-code">{{ins.identity}}</div>
      <div class="insurant-status" :class="calculateApplicantStatusClass(ins, 1)">{{order.pay_time?$maps.APPLICANT_STATUS[ins.applicant_status]:''}}</div>
    </div>

    <expand :default-length="3" :max-length="order.applicant.length"  @expanded="x => collapsed = x" />

    <!-- 底部信息 -->
    <div class="list-bottom">
      <div class="fliggy-bottom-info" v-if="order.ota_info">
        <img src="../assets/imgs/ota-order/fliggy.png"  class="fliggy-logo">
        <div class="fliggy-name" v-if="order.ota_info.ota_store_name">{{order.ota_info.ota_store_name}}</div>
        <router-link class="fliggy-order-num" :to="'/orders/fliggyDetail/'+order.ota_info.ota_sub_order_id" target="_blank">{{order.ota_info.ota_order_id}}</router-link>
      </div>
      <div class="list-account-name">
        <span>负责成员 </span>
        <span class="account-name">
          {{order.peer_account_name}}
        </span>
      </div>
      <div class="list-pay-time">
        <span>支付时间 </span>
        <span class="pay-name">
          {{getPayTime(order.pay_time)}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import dateUtils from '../libs/date-util';
import orderService from '../services/order-service';
import expand from './common/expand';
import ButtonMore from '../pages/ordering/components/button-more.vue';
import OrderInvoiceTag from './order-list/order-invoice-tag.vue';

export default {
  name: 'orderItem',
  props: {
    order: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      collapsed: false,
    };
  },
  components: {
    expand,
    ButtonMore,
    OrderInvoiceTag,
  },
  methods: {

    getPayTime(payTime) {
      return payTime ? moment(payTime).format('YYYY年MM月DD日') : '未支付';
    },

    formatDateWithoutYear: dateUtils.formatDateWithoutYear,
    // 计算订单状态的样式
    calculateOrderStatusClass: orderService.calculateOrderStatusClass,
    // 计算申请人状态的样式
    calculateApplicantStatusClass: orderService.calculateApplicantStatusClass,

    // 跳转订单确认页
    goOrderConfirm() {
      this.$router.push({
        name: 'orderComfirm',
        params: {
          oid: this.order.user_order_id,
        },
        query: {
          admin: 1,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import  '../assets/less/variable';
.order-item {
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
  font-size: 16px;
  margin-bottom: 20px;
  border-radius: 4px;
  .order-title {
    display: flex;
    align-items: center;
    height: 56px;
    border-bottom: 1px solid @border;
    padding: 0 20px;
    justify-content: space-between;
    .title-left {
      display: flex;
      align-items: center;
      height: 56px;
      flex-shrink: 0;
    }
    .title-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-shrink: 0;
      .btn-box{
        display: flex;
        align-items: center;
        gap: 20px;
        >button, >span, >a {
          padding: 0 12px;
          line-height: 28px;
          text-align: center;
          height: 30px;
        }
      }
      

    }
    .title-num {
      padding: 0 12px;
      height: 30px;
      background-color: @bg;
      line-height: 30px;
      font-size: 14px;
      color: @text-sliver;
      text-align: center;
      margin-right: 15px;
      border-radius: 4px;
    }
    .title-name {
      color: @text-dark;
      font-weight: bold;
      width: 430px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .title-status {
      margin-right: 30px;
      flex-shrink: 0;
      padding-left: 24px;
      position: relative;
      font-size: 14px;
      color: @text-dark;
      &::before {
        content: '';
        position: absolute;
        left: 0px;
        top: 0px;
        width: 14px;
        height: 14px;
        background: url(../assets/imgs/insurance/status-common.png) center center no-repeat;
      }
      &.gray-plane {
        color: @text-aaa;
        &::before {
          background: url(../assets/imgs/insurance/status-cancel.png) center center no-repeat;
        }
      }
      &.red-plane {
        color: @text-red;
        &::before {
          background: url(../assets/imgs/insurance/status-process.png) center center no-repeat;
        }
      }
    }
  }

  .list-bottom {
    height: 40px;
    background-color: @active;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    color: @text-aaa;
    padding: 0 20px;
    .fliggy-bottom-info{
      flex-grow: 0;
      margin-right: 100px;
      display: flex;
      align-items: center;
      .fliggy-logo{
        width: 22px;
        flex-shrink: 0;
      }
      .fliggy-name{
        margin-left: 10px;
        flex-shrink: 1;
        max-width: 230px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .fliggy-order-num{
        margin-left: 5px;
        color: #777;
        flex-shrink: 0;
        color: #5e9be1;
      }
    }
    .list-account-name {
      flex-grow: 1;
      .account-name {
        color: @text-sliver;
      }
    }
    .ota {
      padding-right: 20px;
      margin-left: 40px;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
      color: #777;
      display: flex;
      align-items: center;
      .ota-logo {
        width: 22px;
      }
      .ota-name {
        margin-left: 10px;
        margin-right: 8px;
      }
      .store-name {
        margin-left: 8px;
      }
      .ota-order-num {
        margin-left: 10px;
        color: #777;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .list-pay-time {
      text-align: right;
      .pay-time {
        color: @text-sliver;
      }
    }
  }

  .list-expand {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
    margin-bottom: 20px;

    .expand-line {
      height: 1px;
      background-color: @border;
      width: 50%;
    }
    .expand-content {
      cursor: pointer;
      flex-shrink: 0;
      margin: 0 20px;
      padding-right: 22px;
      position: relative;
      font-size: 14px;
      color: @text-sliver;
      span {
        color: @blue;
      }
      &.is-expand {
        &::after {
          transform: rotate(180deg);
        }
      }
      &::after {
        content: '';
        position: absolute;
        right: 0px;
        top: 0px;
        width: 16px;
        height: 16px;
        background: url(../assets/imgs/insurance/insurance-expend-all.png) center center no-repeat;
      }
    }
  }

  .insurant-list {
    margin: 0 auto;
    height: 76px;
    width: 880px;
    display: flex;
    align-items: center;
    border-bottom: 1px dashed @border;
    font-size: 16px;
    color: @text-dark;
    &.no-bottom-border {
      border-bottom-color: transparent;
    }
    .insurant-name {
      flex-shrink: 0;
      min-width: 100px;
      max-width: 100px;
      margin-right: 50px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .insurant-code {
      width: 100px;
      margin-right: 100px;
      color: @text-aaa;
    }
    .insurant-status {
      &.status-red {
        color: @text-red;
      }
      &.status-gray {
        color: @text-aaa;
      }
    }
    .applicant-avatar {
      margin-right: 35px;
    }
    .name-and-identity {
      width: 280px;
      display: flex;
      align-items: center;
      .applicant-name {
        font-size: 18px;
        color: #333;
        margin-right: 10px;
      }
      .applicant-identity {
        font-size: 14px;
        color: #aaa;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-item.vue